import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { PhoneValidator } from "@edp-validators/phone.validator";
import { EdpModalService } from "@edp-components/edp-modal";
import { ContractService } from "../../@services/contract.service";
import { TranslateService } from "@ngx-translate/core";
import { EdpToasterService } from "@edp-components/edp-toaster/edp-toaster.service";
import { EdpToastType } from "@edp-components/edp-toaster/edp-toast-type";
import { EdpResponseBody } from "@edp-models/response.model";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { getDebtInvoices } from "@edp-store/selectors/dashboard.selectors";
import { IInvoice } from "@edp-models/invoices.model";
import { take } from "rxjs/operators";
import { DatalayerService } from "@edp-services/datalayer.service";
import { Router } from "@angular/router";

@Component({
    selector: "edp-sms-payments",
    templateUrl: "./edp-sms-payments.component.html",
    styleUrls: ["./edp-sms-payments.component.scss"]
})
export class EdpSmsPaymentsComponent implements OnInit {
    @Input() data;
    public form: FormGroup;
    public showPhoneError: boolean;
    public disableSubmit: boolean;
    public loading = false;

    private invoice: IInvoice;

    constructor(
        private formBuilder: FormBuilder,
        private edpModalService: EdpModalService,
        private contractService: ContractService,
        private toaster: EdpToasterService,
        private translate: TranslateService,
        private store: Store<IAppState>,
        private datalayerService: DatalayerService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.createFormGroup();

        this.store.select(getDebtInvoices).pipe(
            take(1)
        ).subscribe(invoices => {
            this.invoice = invoices.length ? invoices[0] : null;
        });
    }

    public dismissModal(): void {
        this.edpModalService.dismiss(false);
    }

    private createFormGroup(): void {
        this.form = this.formBuilder.group({
            phoneNumber: [null, [Validators.required, PhoneValidator(true)]]
        });
    }

    private datalayerSubmitSuccess(): void {
        this.datalayerService.setGaClick("paymentMBSendSMSSubmit", {
            interactionLocation: this.router.url.includes("inicio") ? "inicio" : "pagamento-faturas"
        });

        this.datalayerService.setGaEvent("paymentMBSendSMSClose", {
            serviceAttributes: {
                mensagemResultado: this.translate.instant("pt.edp.edponline.endpoint.sucess")
            }
        });
    }

    private datalayerSubmitError(): void {
        this.datalayerService.setGaEvent("paymentMBSendSMSClose", {
            serviceAttributes: {
                mensagemResultado: this.translate.instant("pt.edp.edponline.endpoint.error")
            }
        });
    }

    private datalayerSubmitErrorSendSMS(): void {
        this.datalayerService.setGaClick("paymentMBSendSMSError", {
            interactionLocation: this.router.url.includes("inicio") ? "inicio" : "pagamento-faturas",
            serviceAttributes: {
                campoComErro: "Numero de Telefone"
            }
        });
    }

    public submit(): void {
        this.showPhoneError = false;
        this.loading = true;
        const args = {
            contractId: this.data.contractId,
            ref: {
                faedn: this.data.faedn
            },
            phone: this.form.value.phoneNumber.toString(),
            printDoc: this.invoice ? this.invoice.printDoc : null
        };

        if (this.form.valid) {
            this.disableSubmit = true;
            this.contractService.sendRefMbBySMS(args).subscribe((resp: EdpResponseBody) => {
                if (resp.Success) {
                    this.datalayerSubmitSuccess();

                    this.toaster.create(
                        this.translate.instant("pt.edp.edponline.endpoint.sucess"), EdpToastType.success
                    ).show();
                    this.edpModalService.close(true);

                } else {
                    this.toaster.create(
                        this.translate.instant("pt.edp.edponline.endpoint.error"), EdpToastType.error
                    ).show();

                    this.datalayerSubmitErrorSendSMS();
                    this.datalayerSubmitError();

                    this.edpModalService.close(true);
                }
                this.loading = false;
                this.disableSubmit = false;
            },
                error => {
                    this.datalayerSubmitError();

                    this.toaster.create(
                        this.translate.instant("pt.edp.edponline.endpoint.error"), EdpToastType.error
                    ).show();

                    this.loading = false;
                    this.disableSubmit = false;
                    this.edpModalService.close(true);
                }
            );
        } else {
            this.datalayerSubmitErrorSendSMS();

            this.showPhoneError = true;
        }
    }
}
